export const LEASE_CONSIDERATION_TYPE_MONTHS = {
  'Annual Rent': 12,
  'Free Annual Rent': 12,
  'Monthly Rent': 1,
  'Free Monthly Rent': 1,
};

export const FREE_LEASE_CONSIDERATION_TYPES = [
  'Free Annual Rent',
  'Free Monthly Rent',
];

export const parseConsiderationNumber = (value) => {
  if (value == null || value === '') return 0;
  if (typeof value === 'object' && value !== null && 'parsedValue' in value) {
    return Number(value.parsedValue) || 0;
  }
  return Number(value) || 0;
};

export const roundConsiderationCurrency = value => Math.round((Number(value) || 0) * 10000) / 10000;

export const getConsiderationTermMonths = ({ consideration_type, total_units } = {}) => {
  if (!consideration_type || !total_units) return 0;
  const multiplier = LEASE_CONSIDERATION_TYPE_MONTHS[consideration_type] || 1;
  return (Number(total_units) || 0) * multiplier;
};

export const getTotalConsiderationTermMonths = considerations => (
  (considerations || []).reduce((total, consideration) => total + getConsiderationTermMonths(consideration), 0)
);

const getConsiderationSortValue = (value) => {
  if (value === null || value === undefined || value === '') return Number.MAX_SAFE_INTEGER;
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? Number.MAX_SAFE_INTEGER : numericValue;
};

export const sortConsiderationsByPositionAndId = considerations => (
  [...(considerations || [])].sort((first, second) => {
    const positionDifference = getConsiderationSortValue(first.position_id) - getConsiderationSortValue(second.position_id);
    if (positionDifference !== 0) return positionDifference;
    return getConsiderationSortValue(first.id) - getConsiderationSortValue(second.id);
  })
);

export const getExtractedRentScheduleItems = (rentSchedule) => {
  if (Array.isArray(rentSchedule?.extracted_value) && rentSchedule.extracted_value.length > 0) {
    return rentSchedule.extracted_value;
  }
  if (Array.isArray(rentSchedule?.value) && rentSchedule.value.length > 0) {
    return rentSchedule.value;
  }
  return null;
};

export const buildConsiderationFromExtraction = (item, transaction) => {
  const considerationType = item.consideration_type || 'Monthly Rent';
  const totalUnits = item.total_units !== undefined
    ? parseConsiderationNumber(item.total_units)
    : parseConsiderationNumber(item.consideration_period);
  const isFreeRent = FREE_LEASE_CONSIDERATION_TYPES.includes(considerationType);
  const amount = isFreeRent
    ? 0
    : parseConsiderationNumber(item.amount !== undefined ? item.amount : item.consideration_amount);
  const considerationAmount = isFreeRent ? 0 : roundConsiderationCurrency(amount * totalUnits);

  return {
    consideration_type: considerationType,
    amount,
    total_units: totalUnits,
    transaction,
    consideration_amount: considerationAmount,
    commission_amount: parseConsiderationNumber(item.commission_amount),
    commission_percent: parseConsiderationNumber(item.commission_percent),
  };
};
